import { render, staticRenderFns } from "./myBooks.vue?vue&type=template&id=2880da03"
import script from "./myBooks.vue?vue&type=script&lang=js"
export * from "./myBooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports